import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import TextBlock from '../../../components/TextBlock'
import ProjectDetails from '../../../components/ProjectDetails'
import ProjectHeader from '../../../components/ProjectHeader'
import SingleImage from '../../../components/SingleImage'
import AHref from '../../../components/AHref'

import preview from './gumtree-preview.jpg'

import './index.scss'

class Gumtree extends Component {
  render () {
    const { children } = this.props

    return (
      <div>
        <ProjectHeader
          heading="Evolving and optimising Australia&rsquo;s marketplace"
        />
        <ProjectDetails
          role="User experience designer"
          client="Gumtree Australia"
          agency="Pollen"
          agencylink="https://wwww.pollen.com.au"
          deliverables="User research, user interface design, wireframes, user flows"
        >
        <h2 className="h6">Overview</h2>
        <p>While at <AHref url="https://www.pollen.com.au/">Pollen</AHref>, I&rsquo;ve had the pleasure of working on a range of projects that have helped shape the user experience of Gumtree Australia, a marketplace that sees over 7 million unique users per month.</p>
        <p>Since 2011, Pollen has been working consistently to evolve the online classifieds platform, helping optimise the user experience and later <AHref url="https://www.pollen.com.au/case-study/gumtree-rebrand">turn over a new leaf with a complete rebrand</AHref>.</p>
        </ProjectDetails>
        <SingleImage img={preview} />
        <TextBlock>
          <p>Working closely with Gumtree product and marketing teams, I&rsquo;ve helped optimise the interaction, design and content of pages across the site.</p>
          <p>I&rsquo;ve explored new ways to streamline the processes of selling an item and performing multiple searches.</p>
          <p>I&rsquo;ve also helped conduct user testing sessions with Gumtree buyers and sellers for a range of different products and features.</p>
          <p>Last but not least, I helped <Link to="/projects/gumtree-paypal">integrate peer-to-peer payments to the Gumtree platform</Link>.</p>
          <p>I&rsquo;ve been one very small set of hands involved in the evolution of the Gumtree platform. The work that Pollen has done, particularly the new rebrand, has been received exceptionally well by the Australian public and the team at Gumtree Australia.</p>
        </TextBlock>
      </div>
    )
  }
}

Gumtree.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Gumtree



// WEBPACK FOOTER //
// ./src/pages/projects/gumtree/index.js